import { render } from "./WhiteFooter.vue?vue&type=template&id=7ac3d7a8&scoped=true"
import script from "./WhiteFooter.vue?vue&type=script&lang=js"
export * from "./WhiteFooter.vue?vue&type=script&lang=js"

import "./WhiteFooter.vue?vue&type=style&index=0&id=7ac3d7a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac3d7a8"]])

export default __exports__